import { render, staticRenderFns } from "./addFilePollicy.vue?vue&type=template&id=33a79fda&scoped=true&"
import script from "./addFilePollicy.vue?vue&type=script&lang=js&"
export * from "./addFilePollicy.vue?vue&type=script&lang=js&"
import style0 from "./addFilePollicy.vue?vue&type=style&index=0&id=33a79fda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a79fda",
  null
  
)

export default component.exports